import { Injectable, Inject } from '@angular/core';
import { formatCurrency } from '@angular/common';
import moment from 'moment';
import { min } from 'lodash';

@Injectable({ providedIn: 'root' })
export class CellRenderService {

  constructor(
  ) { }

  renderDate(params: any, formatAfter = 'DD/MM/YYYY', formatBefore = 'YYYY-MM-DD') {
    if (params && !params.value) { return ''; }
    const date = moment(params.value, formatBefore);

    if (moment('0001-01-01').format(formatAfter) != moment.utc(date).format(formatAfter)) {
      return date.isValid() ? date.format(formatAfter) : '';
    }
  }

  renderHour(params: any) {
    if (params && !params.value) { return; }
    
    const duration = moment.duration(params.value);
    const hours = (duration.days() * 24) + duration.hours();
    const minutes = duration.minutes();

    const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    
    return formattedTime;
  }

  renderDateHour(params: any, formatAfter = 'DD/MM/YYYY HH:mm', formatBefore = 'YYYY-MM-DD HH:mm') {
    if (params && !params.value) { return; }
    const date = moment(params.value, formatBefore);

    if (moment('0001-01-01 01:01').format(formatAfter) != moment.utc(date).format(formatAfter)) {
      return date.isValid() ? date.format(formatAfter) : ' - ';
    }
  }

  renderCheckbox(params: any) {
    if (params && params.value == null) { return; }
    return `<input type='checkbox' ${params.value ? 'checked' : ''} disabled='true' >`;
  }

  renderCheckboxWithValueNull(params: any) {
    return `<input type='checkbox' ${params.value ? 'checked' : ''} disabled='true' >`;
  }

  renderCurrency(params: any, locale = 'pt-br', currency = 'R$', currencyCode = 'BRL', digitsInfo = '1.2-2') {
    if (params && params.value == null) { return; }
    return formatCurrency(params.value ? params.value : 0, locale, currency, currencyCode, digitsInfo);
  }

  renderLink(params: any) {
    return params.value ? `<a href="${params.value}" target="_blank" ><i class="fas fa-external-link-alt font-size-16"></i></a>` : '-';
  }

  renderLoading(params: any) {
    if (params.value === undefined) {
      return '<span style="width: 20px;" class="fas fa-spinner fa-spin fa-fw"></span>';
    } else {
      return params.value;
    }
  }
}
